export const ActionsProductMatches = {
	GET_PRODUCT_MATCHES: "get_product_matches",
	LOAD_GET_PRODUCT_MATCHES: "load_get_product_matches",
	RES_GET_PRODUCT_MATCHES: "res_get_product_matches",
	ERR_GET_PRODUCT_MATCHES: "err_get_product_matches",
	HYDRATE: "HYDRATE",
};

export function failureProductMatches(err) {

	return {
		type: ActionsProductMatches.ERR_GET_PRODUCT_MATCHES,
		err,
	};

}

export function loadProductMatches(params = {}) {

	return {
		type: ActionsProductMatches.GET_PRODUCT_MATCHES,
		...params,
	};

}

export function loadGetProductMatches(params = {}) {

	return {
		type: ActionsProductMatches.LOAD_GET_PRODUCT_MATCHES,
		...params,
	};

}

export function loadProductMatchesSuccess(data) {

	return {
		type: ActionsProductMatches.RES_GET_PRODUCT_MATCHES,
		data,
	};

}
